<script>
export default {
  name: 'BaseSelectBox',
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    id: {
      type: String,
      default: null,
      validator(value) {
        return /^[a-zA-Z][\w:.-]*$/.test(value)
      },
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    vuelidate: {
      type: Object,
      default: () => {},
    },
    required: Boolean,
  },
  computed: {
    hasErrors() {
      return this.vuelidate && this.vuelidate.$error
    },
  },
  methods: {
    onChange({ target: { value } }) {
      this.$emit('update', value)
      this.vuelidate && this.vuelidate.$touch()
    },
  },
}
</script>

<template>
  <BaseFormGroup
    :id="id"
    :required="required"
    :label="label"
    :vuelidate="vuelidate"
    :has-errors="hasErrors"
  >
    <select
      :id="id"
      :name="id"
      class="border select"
      :class="
        hasErrors
          ? 'border-volunteer_red'
          : 'border-gray-light focus:border-gray'
      "
      v-bind="$attrs"
      @change="onChange"
      v-on="$listeners"
    >
      <option
        v-for="{ name, value } in options"
        :key="value"
        :value="value"
        v-text="name"
      />
    </select>

    <template v-slot:errors>
      <slot name="errors" />
    </template>
  </BaseFormGroup>
</template>
